(() => {
if (customElements.get('horizontal-scroll')) return;

class HorizontalScroll extends HTMLElement {
  constructor() {
    super();

    this.viewport = null;
    this.previousButton = null;
    this.nextButton = null;
    this.resizeObserver = null;
    this.hasPositionedActiveItem = false;

    this.updateControls = this.updateControls.bind(this);
    this.scrollPrevious = this.scrollPrevious.bind(this);
    this.scrollNext = this.scrollNext.bind(this);
  }

  connectedCallback() {
    if (this.dataset.horizontalScrollInitialized === 'true') return;

    this.viewport = this.querySelector('[data-horizontal-scroll-viewport]');
    this.previousButton = this.querySelector('[data-horizontal-scroll-previous]');
    this.nextButton = this.querySelector('[data-horizontal-scroll-next]');

    if (!this.viewport || !this.previousButton || !this.nextButton) return;

    this.dataset.horizontalScrollInitialized = 'true';
    this.previousButton.addEventListener('click', this.scrollPrevious);
    this.nextButton.addEventListener('click', this.scrollNext);
    this.viewport.addEventListener('scroll', this.updateControls, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.updateControls);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.viewport);
      const content = this.viewport.firstElementChild;
      if (content) this.resizeObserver.observe(content);
    } else {
      window.addEventListener('resize', this.updateControls);
    }

    requestAnimationFrame(() => {
      this.positionActiveItem();
      this.updateControls();
    });
  }

  disconnectedCallback() {
    if (!this.viewport) return;

    this.previousButton?.removeEventListener('click', this.scrollPrevious);
    this.nextButton?.removeEventListener('click', this.scrollNext);
    this.viewport.removeEventListener('scroll', this.updateControls);
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.updateControls);
    delete this.dataset.horizontalScrollInitialized;
  }

  positionActiveItem() {
    if (this.hasPositionedActiveItem || !this.viewport) return;

    const activeItem = this.viewport.querySelector('.active');
    if (!activeItem) return;

    const item = activeItem.closest('li') || activeItem;
    const itemStart = item.offsetLeft;
    const itemEnd = itemStart + item.offsetWidth;
    const visibleStart = this.viewport.scrollLeft;
    const visibleEnd = visibleStart + this.viewport.clientWidth;

    if (itemStart < visibleStart || itemEnd > visibleEnd) {
      this.viewport.scrollLeft = Math.max(
        0,
        itemStart - (this.viewport.clientWidth - item.offsetWidth) / 2
      );
    }

    this.hasPositionedActiveItem = true;
  }

  getScrollDistance() {
    return Math.max(this.viewport.clientWidth * 0.75, 120);
  }

  scrollPrevious() {
    this.viewport.scrollBy({ left: -this.getScrollDistance(), behavior: 'smooth' });
  }

  scrollNext() {
    this.viewport.scrollBy({ left: this.getScrollDistance(), behavior: 'smooth' });
  }

  updateControls() {
    if (!this.viewport) return;

    const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    const isOverflowing = maximumScroll > 1;
    const currentScroll = Math.max(0, this.viewport.scrollLeft);

    this.toggleAttribute('data-overflowing', isOverflowing);
    this.previousButton.disabled = !isOverflowing || currentScroll <= 1;
    this.nextButton.disabled = !isOverflowing || currentScroll >= maximumScroll - 1;
  }
}

customElements.define('horizontal-scroll', HorizontalScroll);
})();
